<!-- 通话小结 -->
<template>
  <div class="TableCommunication">
    <div class="search-container">
      <div class="search-item">
        <a-select
          v-model:value="queryParam.callPhoneType"
          placeholder="选择通话类型"
          style="width: 224px"
          size="large"
          allowClear
        >
          <a-select-option
            :value="item.value"
            v-for="item in callPhoneTypeOptions"
            :key="item.value"
          >
            {{ item.label }}
          </a-select-option>
        </a-select>
      </div>
      <div class="search-item">
        <a-select
          v-model:value="queryParam.endStatus"
          placeholder="选择通话状态类型"
          style="width: 224px"
          size="large"
          allowClear
        >
          <a-select-option :value="item.value" v-for="item in statusOptions" :key="item.value">
            {{ item.label }}
          </a-select-option>
        </a-select>
      </div>
      <div class="search-item">
        <a-range-picker
          size="large"
          v-model:value="dateList"
          :placeholder="['开始日期', '结束日期']"
          allowClear
          format="YYYY-MM-DD"
          :ranges="rangePresets"
          dropdownClassName="creatTime"
          :disabledDate="disabledDate"
        />
      </div>
      <div class="search-item">
        <a-button class="search-button" size="large" type="primary" @click="searchList">
          搜索
        </a-button>
      </div>
    </div>
    <a-table
      :loading="loading"
      :transformCellText="({ text }) => text ?? '--'"
      :bordered="true"
      :pagination="pagination"
      :dataSource="dataSource"
      :columns="col"
      :scroll="{ y: 300, x: 100 }"
      @change="change"
      :rowKey="(_, index) => index"
    >
      <!-- 呼出人， callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
      <template #callerType="{ record }">
        <div class="service_person">
          <roles :solerType="record.callerType" />
          <span>{{ maskPatientName(record.callerName, record.callerType) }}</span>
        </div>
      </template>
      <!-- 接听人 callerType主叫方类型：1患者、2医生、3bd、4医生助手-->
      <template #calleeName="{ record }">
        <div class="service_person">
          <roles :solerType="record.calleeType" />
          <span>{{ maskPatientName(record.calleeName, record.calleeType) }}</span>
        </div>
      </template>
      <!-- 电话时长 -->
      <template #duration="{ record, index }">
        <template v-if="record.duration">
          <div v-if="record.isPlay">
            <audio :src="record.audioUrl" controls ref="audioRef"></audio>
          </div>
          <div v-else @click="onPlay(index)" class="call_duration">
            <img class="icon" :width="16" :height="16" :src="playIcon" />
            <span>{{ renderTime(record.duration) }}</span>
          </div>
        </template>
        <template v-else>--</template>
      </template>
      <template #operate="{ record }">
        <div v-if="record.buttonDisplay || record.readSummaryCheck">
          <a :style="{ marginRight: '10px' }" @click="openFullText(record)">通话全文</a>
          <!-- 只有本人可以编辑 编辑提交后全员可看 -->
          <a v-if="record.readSummaryCheck" @click="handleSummary(record)">查看小结</a>
          <!-- ai生成失败 -->
          <template v-if="record.chatSummaryStatus === 0">
            <a v-if="record.chatSummaryRetryCount < 2" @click="onCreateSummary(record)">
              AI重新生成小结
            </a>
            <a v-else v-show="record.writeSummaryCheck" @click="handleSummary(record)">填写小结</a>
          </template>
        </div>
        <span v-else>--</span>
      </template>
    </a-table>
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :maskClosable="false"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <summaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible = false"
      />
    </a-modal>
    <FullText ref="FullTextRef" />
    <EditSummary ref="editSummaryRef" @changeTab="getData" />
  </div>
</template>

<script setup>
import playIcon from '@/assets/img/chat/playIcon.png'
import { getCdrList, getTccEndStatus, getTccType } from '@/api/chat'
import { renderTime, maskPatientName } from '@/utils'
import { ColCommunication as col } from '@/components/PatientFile/config'
import FullText from '@/components/FullText/index.vue'

import { computed, nextTick, onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useSummary } from '@/hooks/useSummary'
import EditSummary from '@/views/WorkPlace/Container/Summary/editSummary.vue'
import summaryPannel from '@/views/WorkPlace/Container/chat/components/summaryPannel/index.vue'
import {
  rangePresets,
  disabledDate,
  formatDateForFilter
} from '@/components/PatientFile/ModalBody/tags/PlatformService/config'

const store = useStore()
const ucPatientId = computed(() => store.state.patientFile.info.ucPatientId)
const info = computed(() => store.state.patientFile.info)
const patientType = computed(() => store.state.patientFile.patientType)
const dataSource = ref([])
const dateList = ref([])
const pagination = ref({
  current: 1,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  total: 0,
  showTotal: () => {}
})
const statusOptions = ref([])
const callPhoneTypeOptions = ref([])
const queryParam = {
  endStatus: '',
  callPhoneType: ''
}
const loading = ref(false)
const searchList = () => {
  getData()
}
async function getData() {
  const query = {
    pageNo: pagination.value.current,
    pageSize: pagination.value.pageSize,
    ucPatientId: patientType.value ? ucPatientId.value : null,
    prePatientId: patientType.value === 0 ? info.value.prePatientId : null,
    ...queryParam
  }
  const [startTime, endTime] = formatDateForFilter(dateList.value)
  query.startQueryTime = startTime
  query.endQueryTime = endTime
  loading.value = true
  dataSource.value = []
  getCdrList(query)
    .then(result => {
      const { list, totalCount } = result
      pagination.value.total = totalCount
      dataSource.value = list.map(v => {
        return {
          ...v,
          isPlay: false
        }
      })
      pagination.value.showTotal = () => `共${totalCount}条`
    })
    .catch(err => {})
    .finally(() => {
      loading.value = false
    })
}
const { editSummaryRef, chatSummaryId, summaryPanelVisible, handleSummary, onCreateSummary } =
  useSummary(getData)
const change = page => {
  pagination.value.current = page?.current || 1
  pagination.value.pageSize = page?.pageSize || 10
  getData()
}
const audioRef = ref(null)
// 播放录音
const onPlay = index => {
  console.log(index)
  dataSource.value.forEach((it, i) => {
    it.isPlay = index === i
  })
  nextTick(() => {
    audioRef.value.play()
  })
}

// 获取通话类型
const getCallPhoneTypeOptions = () => {
  getTccType().then(res => {
    callPhoneTypeOptions.value = res.map(it => {
      return { label: it.value, value: it.code }
    })
    callPhoneTypeOptions.value.unshift({
      label: '全部类型',
      value: ''
    })
  })
}
// 获取通话记录状态
const getStatusOptions = () => {
  getTccEndStatus().then(res => {
    statusOptions.value = res.map(it => {
      return { label: it.value, value: it.code }
    })
    statusOptions.value.unshift({
      label: '全部通话状态',
      value: ''
    })
  })
}
const FullTextRef = ref(null)
const openFullText = record => {
  const { cdrId } = record
  FullTextRef.value.openModal(cdrId)
}

onMounted(() => {
  getStatusOptions()
  getCallPhoneTypeOptions()
  change()
})
</script>

<style lang="scss" scoped>
.TableCommunication {
  .search-container {
    // padding: 10px 20px 0 0;
    background-color: #ffffff;
    .search-item {
      display: inline-block;
      margin-bottom: 10px;
      margin-right: 12px;
      .search-input {
        width: 224px;
      }
    }
  }
  .call_duration {
    display: flex;
    align-items: center;
    cursor: pointer;
    .icon {
      margin-right: 8px;
    }
  }
}
</style>
